// @flow

import React from 'react';
import { connect } from 'react-redux';
import { TileSelect, Tile } from '../../../tileSelect';
import OptionColor from '../../../configColor';
import { getPerMonthAbbrv } from '../../../../../../store/configuratorSettings/selectors';
import type { PackageColor } from '../../../../../../types/pdb';
import withPdbColors from '../atoms/withPdbColors';

type StateProps = {|
  postfix: string,
|};

type DispatchProps = {|
  setColor: Function,
|};

type OwnProps = {|
  colors: Array<PackageColor>,
  activeColorId: ?number,
  ...DispatchProps,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Colors = ({
  colors, activeColorId, setColor, postfix,
}: Props) => (
  <TileSelect>
    {colors.map(({
      id, name, price, hexcode, addColors,
    }) => (
      <Tile
        key={id}
        active={activeColorId === id}
        onClick={() => setColor(id)}
        blocksPerRow={2}
        blockCount={colors.length}
        boxed={false}
      >
        <OptionColor
          color={`#${hexcode}`}
          stock="0"
          fromPrice="0" // Currently not available
          title={name}
          price={price}
          postfix={postfix}
          active={activeColorId === id}
          twoToneColor={addColors && `#${addColors.hexcode}`}
          twoToneTitle={addColors && addColors.name}
        />
      </Tile>
    ))}
  </TileSelect>
);

const mapStateToProps = (state): StateProps => ({
  postfix: getPerMonthAbbrv(state),
});

export default withPdbColors(connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(Colors));
